// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "../Icon", "cva"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("../Icon"), require("cva"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.Icon, global.cva);
    global.TextLink = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _Icon, _cva) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.TextLink = TextLink;
  _react = _interopRequireDefault(_react);
  var _excluded = ["children", "variant", "className", "disabled", "external"];
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
  function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
  var textLinkClasses = (0, _cva.cva)({
    base: 'cop-flex cop-items-center cop-gap-1.5 outline-none cop-outline-solid cop-outline-link cop-outline-offset-[3px] cop-w-fit cop-underline-offset-[3px]',
    variants: {
      variant: {
        "default": 'cop-text-link cop-no-underline hover:cop-text-link-hover hover:cop-underline active:cop-text-link-active active:cop-underline',
        secondary: 'cop-text-primary cop-underline hover:cop-no-underline active:cop-no-underline',
        minimal: 'cop-text-secondary cop-no-underline hover:cop-underline hover:cop-text-primary active:cop-text-primary active:cop-underline'
      },
      disabled: {
        "true": 'cop-opacity-[0.45] cop-pointer-events-none'
      }
    }
  });
  function TextLink(_ref) {
    var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$external = _ref.external,
      external = _ref$external === void 0 ? false : _ref$external,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/_react["default"].createElement("a", _extends({
      className: textLinkClasses({
        variant: variant,
        className: className,
        disabled: disabled
      })
    }, props), children, external && /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
      icon: "ArrowNE",
      className: "cop-h-[calc(1em-1px)]" // Using em units to match current font size
    }));
  }
});
